// ============================================================================
// BUILD INFO — the git short SHA and build timestamp, read off the screen.
//
// The owner has been bitten repeatedly by a stale cached build that LOOKS like
// today's deploy (a service worker or a browser disk cache serving yesterday's
// bundle) — see the `skipWaiting`/`clientsClaim` comment in vite.config.ts for
// the same problem attacked from the PWA side. This is the other half: a badge
// that states which build is actually running, so "is this the new one" is a
// glance, not a guess.
//
// `__BUILD_SHA__` / `__BUILD_TIME__` are string literals baked in at build time
// by vite.config.ts's `define` — see there for the `git rev-parse` call and its
// 'dev' fallback. They do not exist at runtime as real globals; declared for TS
// in src/global.d.ts.
// ============================================================================

export const BUILD_SHA: string = __BUILD_SHA__
export const BUILD_TIME: string = __BUILD_TIME__
